module.exports = __webpack_public_path__ + "static/media/wind.14611c6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/wind.png
// module id = 73
// module chunks = 0